import { VisibilityRuleMap } from '../types/featureVisibility.types';
import { F, MenuFeatureKey } from '../types/features.keys';
import {
  and,
  canMenu,
  canRead,
  canUpdate,
  hasFlag,
  hasIntegrations,
  isBrandEnv,
  isNeverVisible,
  isNotOfflineMode,
  isNotStore,
  isStore,
  isStoreEnv,
  isTeceoAdmin,
  not,
  or,
} from './visibility.combinators';

export const menuVisibilityRules: Pick<VisibilityRuleMap, MenuFeatureKey> = {
  [F.menu.home]: and(isNotOfflineMode, or(isStoreEnv, not(hasFlag('isEnableRachelChat')))),
  [F.menu.rachel]: and(isNotOfflineMode, hasFlag('isEnableRachelChat')),
  [F.menu.connections]: and(isNotOfflineMode, canMenu('connections')),
  [F.menu.showroom]: and(isBrandEnv, isNotOfflineMode, canMenu('showroom')),
  [F.menu.catalogs]: and(isBrandEnv, canMenu('catalogs')),
  [F.menu.orders]: canMenu('page-orders'),
  [F.menu.storeOrders]: and(isStoreEnv, isNotOfflineMode, canMenu('store-orders'), isNeverVisible),
  [F.menu.customers]: and(isNotOfflineMode, canMenu('customers')),
  [F.menu.salesOpportunities]: and(
    isNotOfflineMode,
    canMenu('sales-opportunities'),
    hasFlag('isSalesOpportunityEnabled'),
  ),
  [F.menu.targets]: and(
    isNotOfflineMode,
    canMenu('targets'),
    or(isStoreEnv, and(isBrandEnv, isNotStore)),
  ),
  [F.menu.reports]: and(isNotOfflineMode, canMenu('reports')),
  [F.menu.analytics]: and(
    isNotOfflineMode,
    canRead('lightdash-reports'),
    hasFlag('isEnableLightdashReports'),
  ),
  [F.menu.cases]: and(isBrandEnv, isNotOfflineMode, canMenu('cases'), hasFlag('isEnableCases')),
  [F.menu.invoices]: and(
    isNotOfflineMode,
    canMenu('invoices'),
    or(isStore, and(hasFlag('isEnableInvoices'), hasIntegrations)),
  ),
  [F.menu.locals]: and(isBrandEnv, isNotOfflineMode, canMenu('locals')),
  [F.menu.accountsReceivable.receivable]: and(
    isNotOfflineMode,
    canMenu('accounts-receivable'),
    hasFlag('isAccountsReceivableEnabled'),
    isNotStore,
  ),
  [F.menu.accountsReceivable.payable]: and(
    isNotOfflineMode,
    canMenu('accounts-receivable'),
    hasFlag('isAccountsReceivableEnabled'),
    isStore,
  ),
  [F.menu.settings]: and(isNotOfflineMode, canMenu('settings')),
  [F.menu.profile]: and(isNotOfflineMode, canMenu('profile')),
  [F.menu.storefront]: and(
    isNotOfflineMode,
    canMenu('storefront'),
    or(canUpdate('storefront'), isStore),
  ),
  [F.menu.teams]: canMenu('teams'),
  [F.menu.adminTeceo]: and(isNotOfflineMode, isTeceoAdmin, canMenu('teams')),
  [F.menu.logout]: and(isNotOfflineMode, canMenu('profile')),
};
